import PropTypes from 'prop-types'
import { eventSelector } from '../../../selectors'
import React from 'react'
import { connect } from 'react-redux'
import LeftChevronIcon from '../../../assets/icons/left_chevron.svg'
import CopyIcon from '../../../assets/icons/icon-copy.svg'
import SvgIcon from '../../../components/common/SvgIcon'
import styles from './send-invites-manually.scss'
import cn from 'classnames'
import { Tooltip, message } from 'antd'

class SendInvitesManually extends React.Component {
  constructor() {
    super()
    this.state = {
      isTooltipShown: false
    }
  }

  timeoutHandle = null

  render() {
    return <main className={styles['main-container']}>
      <header>
        <SvgIcon
          className={styles['back-icon']}
          width={20}
          height={20}
          icon={LeftChevronIcon} padding='5px' onClick={() => {
          if (this.props.onGoBack) {
            this.props.onGoBack()
          }
        }} />
        <h1>Send Invites Manually</h1>
      </header>
      {this.props.event && <section className={cn(styles['share-info-container'])}>
        {/* <section className={cn(styles['qr-code-container'], styles['share-sections'])}> */}
        {/*  <p>Scan this code to finish sending invites on your phone</p> */}
        {/*  <QRCodeSVG value={this.props.event.share_url} fgColor={'#2CD4AE'} size={145} /> */}
        {/* </section> */}
        {/* <div className={cn(styles['divider'], styles['share-sections'])}> */}
        {/*  OR */}
        {/* </div> */}
        <section className={cn(styles['url-container'], styles['share-sections'])}>
          <p>Click to copy the public event link</p>
          <div className={styles['copy-url-container']}>
            <Tooltip placement="top" title={'Copied!'} open={this.state?.isTooltipShown}>
              <p>{this.props.event?.share_url}</p>
            </Tooltip>
            <SvgIcon
              width={20}
              height={20}
              icon={CopyIcon}
              onClick={() => {
                message.success('Copied!')
                this.setState({ isTooltipShown: true })
                navigator.clipboard.writeText(this.props.event?.share_url)
                if (this.timeoutHandle) {
                  clearTimeout(this.timeoutHandle)
                  this.timeoutHandle = null
                }
                this.timeoutHandle = setTimeout(() => {
                  this.setState({ isTooltipShown: false })
                }, 2000)
              }} />
          </div>
        </section>
      </section>}
    </main>
  }
}

function mapStateToProps(state) {
  return {
    event: eventSelector(state)
  }
}

SendInvitesManually.propTypes = {
  event: PropTypes.object,
  onGoBack: PropTypes.func
}

export default connect(mapStateToProps)(SendInvitesManually)
